import React from 'react';
import PropTypes from 'prop-types';

function MapPointIcon({ w, h, style, className }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={`${w}px`}
      height={`${h}px`}
      viewBox="0 0 24 24"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        d="M12 3c3.314 0 6 2.389 6 6 0 2.407-2 6.074-6 11-4-4.926-6-8.593-6-11 0-3.611 2.686-6 6-6zm0 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
      />
    </svg>
  );
}

MapPointIcon.defaultProps = {
  w: 24,
  h: 24,
  style: {},
};

MapPointIcon.propTypes = {
  w: PropTypes.number,
  h: PropTypes.number,
  style: PropTypes.shape({}),
  className: PropTypes.string,
};

export default MapPointIcon;
